import autosize from 'autosize';

const _initAutosize = function _initAutosize() {
  autosize($('textarea'));
};

const registerEventBindings = function registerEventBindings() {
  _initAutosize();
};

const UICommunityNew = {
  registerEventBindings,
};

export default UICommunityNew;
